import { Modal, TextInput } from '@mantine/core';

import { useForm, Controller } from 'react-hook-form';

import { useEffect, useState } from 'react';
import JoditEditor from 'jodit-react';
import SecondaryButton from 'components/secondaryButton';
import PrimaryButton from 'components/primaryButton';
import ThumbnailEmployeeModal from './thumbnailemployee';

import Useaddnewemployeeblog from '../hooks/useAddnewemployeeblog';
import useGetemployeeblogsmodal from '../hooks/useGetEmployeemodalData';
import useUpdateemployeeblog from '../hooks/useUpdateemployeeblog';

const AddNewStroryEmployeeModal = ({
  setNewStoryModal,
  newStoryModal,
  setBlogId,
  BlogId,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    reset,
    setValue,
  } = useForm({ mode: 'onChange' });

  useEffect(() => {
    if (!newStoryModal) {
      reset();
    }
    // eslint-disable-next-line
  }, [newStoryModal]);

  //   get blog data
  const blogData = useGetemployeeblogsmodal(BlogId);

  useEffect(() => {
    if (!!BlogId && blogData.isSuccess) {
      setValue('topic', blogData?.data?.data[0].topic);
      setValue('title', blogData?.data?.data[0].title);
      setValue('content', blogData?.data?.data[0].content);
      setValue('minutes', blogData?.data?.data[0].minutes);
    }
    // eslint-disable-next-line
  }, [blogData?.data?.data, BlogId]);

  const defaultValues = {
    topic: '',
    title: '',
    content: '',
  };

  const [moveToNextPage, setMoveToNextPage] = useState(false);
  const [lastData, setLastData] = useState(null);

  const config = {
    minHeight: 300,
    autofocus: false,
    maxHeight: 600,
    readonly: false,
    fullsize: false,
    globalFullSize: false,
    uploader: {
      insertImageAsBase64URI: true,
    },
    useSearch: false,
    spellcheck: true,
    controls: {
      font: {
        list: {
          'lato, sans-serif': 'lato',
          'Raleway, sans-serif': 'Raleway',
        },
      },
    },
    // toolbarAdaptive: false,
    style: {
      background: '#FFF4F1',
    },

    // all options from https://xdsoft.net/jodit/doc/
  };

  const submitData = (data) => {
    setMoveToNextPage(true);
    setLastData(data);
    reset();
  };

  const clodemodalwhenDraftSave = () => {
    setNewStoryModal(false);
    reset({ defaultValues });
    setBlogId(null);
    reset();
  };
  //  Add new blog mutation
  const addNewBlogMutation = Useaddnewemployeeblog(clodemodalwhenDraftSave);
  const UpdateBlogMutation = useUpdateemployeeblog(clodemodalwhenDraftSave);

  const saveAsdraft = () => {
    if (watch('title') !== undefined) {
      if (watch('title') !== '') {
        if (watch('topic') !== undefined) {
          if (watch('topic') !== '') {
            if (watch('content') !== undefined) {
              if (watch('content') !== '') {
                if (watch('minutes') !== undefined) {
                  if (watch('minutes') !== '') {
                    const formDate = new FormData();

                    formDate.append('topic', watch('title'));
                    formDate.append('title', watch('topic'));
                    formDate.append('content', watch('content'));
                    formDate.append('minutes', watch('minutes'));
                    formDate.append('is_draft', 'True');
                    formDate.append('is_deleted', 'False');
                    formDate.append('is_published', 'False');

                    if (!BlogId) {
                      addNewBlogMutation.mutate(formDate);
                    } else {
                      formDate.append('id', BlogId);
                      UpdateBlogMutation.mutate(formDate);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  const getErrorMessage = (name) => {
    return (
      errors[name] && (
        <p className=' text-xs font-semibold text-red-500'>
          {errors[name]?.message}
        </p>
      )
    );
  };

  return (
    <div>
      <Modal
        opened={newStoryModal}
        onClose={() => {
          clodemodalwhenDraftSave();
          setNewStoryModal(false);
          reset({ defaultValues });
          setBlogId(null);
        }}
        title='Composing a story'
        size={'60%'}
        centered
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        transitionDuration={100}
        overflow='inside'
        className='px-10'
        classNames={{
          title: 'text-lg font-semibold mx-auto',
          body: 'scroller h-full',
        }}
      >
        {moveToNextPage ? null : (
          <form onSubmit={handleSubmit(submitData)} className='mx-4'>
            <div>
              <Controller
                control={control}
                name='topic'
                rules={{
                  required: 'required',
                  validate: () =>
                    watch('topic').length < 249 ||
                    'maximum length exceded (250 chars)',
                }}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    placeholder='Add  a topic/ category for your story'
                    size='lg'
                    classNames={{
                      input: 'border-primary mt-0.5',
                      label: 'text-neutralsGrey text-sm',
                    }}
                  />
                )}
              />
              {getErrorMessage('topic')}
            </div>
            <div>
              <Controller
                control={control}
                name='title'
                rules={{
                  required: 'required',
                  validate: () =>
                    watch('title').length < 249 ||
                    'maximum length exceded (250 chars)',
                }}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    placeholder='Add a title'
                    size='lg'
                    className='mt-4'
                    classNames={{
                      input: 'border-primary mt-0.5',
                      label: 'text-neutralsGrey text-sm',
                    }}
                  />
                )}
              />
              {getErrorMessage('title')}
            </div>
            <div className='mt-4 '>
              <Controller
                control={control}
                name='content'
                rules={{ required: 'required' }}
                render={({ field }) => (
                  <JoditEditor
                    config={config}
                    {...field}
                    value={field.value}
                    onChange={(e) => {}}
                    onBlur={(e) => field.onChange(e)}
                    //   ref={editor}
                    // value={watch('content')}
                    // tabIndex={1} // tabIndex of textarea
                  />
                )}
              />
              {getErrorMessage('content')}
            </div>
            <div className='flex justify-end'>
              <div>
                <Controller
                  control={control}
                  name='minutes'
                  rules={{
                    required: 'required',
                    min: { value: 1, message: 'invalid time' },
                  }}
                  defaultValue=''
                  render={({ field }) => (
                    <TextInput
                      {...field}
                      placeholder='Estimated reading time (in mins)'
                      size='md'
                      type='number'
                      className='mt-12'
                      classNames={{
                        input: 'w-72 border-primary bg-[#FFE8E1] mt-0.5',
                        label: 'text-neutralsGrey text-sm',
                      }}
                    />
                  )}
                />
                {getErrorMessage('minutes')}
              </div>
            </div>

            {/* <div className='grid grid-cols-2 gap-4'>
              <div>
                <Controller
                  control={control}
                  name='minutes'
                  // rules={{ required: 'required' }}
                  render={({ field }) => (
                    <TextInput
                      {...field}
                      // placeholder='Enter'
                      label='Time to Read'
                      size='md'
                      className='mt-4'
                      classNames={{
                        input: 'border-primary mt-0.5',
                        label: 'text-neutralsGrey text-sm',
                      }}
                    />
                  )}
                />
                {errors.minutes && (
                  <p className='text-sm  text-[#fc0101]'>
                    {errors.minutes.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  control={control}
                  name='tabs'
                  // rules={{ required: 'required' }}
                  render={({ field }) => (
                    <TextInput
                      {...field}
                      // placeholder='Add a title'
                      label='   '
                      size='md'
                      className='mt-4'
                      classNames={{
                        input: 'border-primary mt-0.5',
                        label: 'text-neutralsGrey text-sm',
                      }}
                    />
                  )}
                />
                {errors.title && (
                  <p className='text-sm  text-[#fc0101]'>
                    {errors.title.message}
                  </p>
                )}
              </div>
            </div> */}

            <div className='flex justify-center items-center gap-3 my-8'>
              <button
                type='button'
                onClick={() => {
                  saveAsdraft();
                }}
              >
                <SecondaryButton>Save as draft</SecondaryButton>
              </button>
              <button>
                <PrimaryButton>Save and Next</PrimaryButton>
              </button>
            </div>
          </form>
        )}
      </Modal>
      <ThumbnailEmployeeModal
        moveToNextPage={moveToNextPage}
        setMoveToNextPage={setMoveToNextPage}
        lastData={lastData}
        defaultValues={defaultValues}
        setNewStoryModal={setNewStoryModal}
        BlogId={BlogId}
        // thumbnailImage={
        //   blogData?.data?.data.length === 0
        //     ? null
        //     : blogData?.data?.data[0].thumbnail
        // }
        thumbnailImage={BlogId ? blogData?.data?.data[0].thumbnail : null}
      />
    </div>
  );
};

export default AddNewStroryEmployeeModal;
